export default {
  description: state => state.description,
  products: state => state.products,
  suggestions: state => state.suggestions,
  productsCount: state => state.total,
  provider: state => state.provider
};